// combatpro/dice/DiceHistory.js
//
// Combat PRO - DiceHistory (Stage 36: roll history render + clear).
//
// Renders the dice roll history from React state (state.diceHistory) and
// provides clear-history behaviour. This replaces the legacy DOM history
// renderer updateRollHistory in battletracker.html, which built history HTML via
// innerHTML into roll-history-{index}. Here the render is declarative React.
//
// Source behaviour reproduced (battletracker.html):
//   - History order is newest-first and capped at 10 entries. That cap and order
//     are applied in DiceView when appending (matching addRollToHistory's
//     unshift + length > 10 pop); this component renders whatever it receives.
//   - clearRollHistory(index) exists in the source, so a Clear button is
//     provided and wired to the onClearHistory prop. DiceView implements the
//     state reset.
//   - The empty state mirrors the source's "No rolls yet" message.
//
// Presentational only: no dice mathematics, no state ownership, no storage, no
// API, no AI, no getElementById, no innerHTML. Each entry renders its formula
// and total. No optional chaining. No em dash.

import React from 'react';

function DiceHistory(props) {
  var diceHistory = props.diceHistory;

  return (
    <div className="vi-roll-history">
      <div className="vi-roll-history-hdr">
        <span className="vi-roll-history-title">Roll History</span>
        <button type="button" className="vi-roll-history-clear" onClick={function () { props.onClearHistory(); }}>Clear</button>
      </div>
      <div className="vi-roll-history-inner">
        {diceHistory.length === 0 ? (
          <div className="vi-empty">No rolls yet</div>
        ) : (
          diceHistory.map(function (entry, index) {
            return (
              <div key={index} className="vi-roll-entry">
                <span className="vi-roll-entry-label">{entry.label ? entry.label : 'Roll'}</span>
                <span className="vi-roll-entry-formula">{entry.formula}</span>
                <span className="vi-roll-entry-total">{entry.total}</span>
              </div>
            );
          })
        )}
      </div>
    </div>
  );
}

export default DiceHistory;
